import { Input } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import { translate } from '../../languages'
import { RootState } from '../../stores'

type ColumnInputRangeHeaderProps = {
  titleKey: string
  fromKey: string
  toKey: string
  onFromChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onToChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  fromValue?: string | number
  toValue?: string | number
}

export const ColumnInputRangeHeader: React.FC<ColumnInputRangeHeaderProps> = ({
  titleKey,
  fromKey,
  toKey,
  onFromChange,
  onToChange,
  fromValue,
  toValue,
}) => {
  const { language } = useSelector((state: RootState) => state.language)

  const isDesktopScreen = useMediaQuery({ minWidth: '1300px' })

  return (
    <>
      <span>{translate(titleKey, language)}</span>
      {isDesktopScreen && (
        <div>
          <Input
            placeholder={translate(fromKey, language)}
            addonBefore={translate(fromKey, language)}
            value={fromValue}
            type="number"
            style={{ width: '49%' }}
            allowClear
            onChange={(e: any) => onFromChange(e)}
          />
          <Input
            placeholder={translate(toKey, language)}
            addonBefore={translate(toKey, language)}
            value={toValue}
            type="number"
            style={{ width: '49%', float: 'right' }}
            allowClear
            onChange={(e: any) => onToChange(e)}
          />
        </div>
      )}
    </>
  )
}
